import { token } from "../../App";

function EatMore(
  prevSquareIndex,
  currentSquareIndex,
  boardData,
  setPlayerTurn,
  playerTurn,
  squareRef,
  squareRefPawns,
  setBoardData,
  x
) {
  x = 1;
  if (playerTurn === 2) {
    if (
      (currentSquareIndex > 18 &&
        boardData[currentSquareIndex][0] === 2 &&
        (boardData[currentSquareIndex - 9][0] === 1 ||
          boardData[currentSquareIndex - 9][0] === 31) &&
        boardData[currentSquareIndex - 18][0] === 0) ||
      (currentSquareIndex > 22 &&
        boardData[currentSquareIndex][0] === 2 &&
        (boardData[currentSquareIndex - 11][0] === 1 ||
          boardData[currentSquareIndex - 11][0] === 31) &&
        boardData[currentSquareIndex - 22][0] === 0)
    ) {
      const eatMore = document.querySelector(".eat-more");
      const mustEat = document.querySelector(".must-eat");

      if (eatMore) {
        eatMore.style.display = "block";
        mustEat.style.display = "none";
        setTimeout(() => {
          eatMore.style.display = "none";
        }, 1000);
      }
      setPlayerTurn(2);
      x = 2;
      token(currentSquareIndex);
    }
  } else if (playerTurn === 1) {
    if (
      (currentSquareIndex < 80 &&
        boardData[currentSquareIndex][0] === 1 &&
        (boardData[currentSquareIndex + 9][0] === 2 ||
          boardData[currentSquareIndex + 9][0] === 32) &&
        boardData[currentSquareIndex + 18][0] === 0) ||
      (currentSquareIndex < 78 &&
        boardData[currentSquareIndex][0] === 1 &&
        (boardData[currentSquareIndex + 11][0] === 2 ||
          boardData[currentSquareIndex + 11][0] === 32) &&
        boardData[currentSquareIndex + 22][0] === 0)
    ) {
      const eatMore = document.querySelector(".eat-more");
      const mustEat = document.querySelector(".must-eat");

      if (eatMore) {
        eatMore.style.display = "block";
        mustEat.style.display = "none";

        setTimeout(() => {
          eatMore.style.display = "none";
        }, 1000);
      }
      setPlayerTurn(1);
      x = 2;
      token(currentSquareIndex);
    }
  }
  return x;
}

export default EatMore;
